// extracted by mini-css-extract-plugin
module.exports = {"Container":"Counter_Container__256Hq","Input":"Counter_Input__1cLob","ControlIcon":"Counter_ControlIcon__2iezu","right":"Counter_right__9BMpM","left":"Counter_left__3G1gR"};